import React from 'react'
import { Form, Formik } from 'formik'
import { object, string } from 'yup'
import { MenuItem, Select } from '@mui/material'
import FormTextField from '../../../shared/ui/FormTextField'
import CancelBtn from '../../../shared/ui/CancelBtn'
import PrimaryBtn from '../../../shared/ui/PrimaryBtn'

const FORM_INITIAL_STATE = {
    clientName: '',
    password: '',
    threshold: '',
    spoofingThreshold: '',
    isActive: '',
}

const VALIDATION_SCHEMA = object().shape({
    clientName: string().when('formType', {
        is: 'details',
        then: string().required('Name is required'),
    }),
    password: string().when('formType', {
        is: 'changePassword',
        then: string().required('Password is required'),
    }),
})

const booleanOption = [
    {
        value: true,
        label: 'TRUE',
    },
    {
        value: false,
        label: 'FALSE',
    },
]

export default function ClientForm({
    onSubmit = () => {},
    onClose = () => {},
    initialValues,
    loading,
    isEdit,
    item,
}) {
    return (
        <Formik
            enableReinitialize
            initialValues={{
                ...FORM_INITIAL_STATE,
                ...initialValues,
                ...item,
            }}
            validationSchema={VALIDATION_SCHEMA}
            onSubmit={onSubmit}
        >
            {({ handleChange, values, setFieldValue }) => (
                <Form className="h-[75%] flex flex-col justify-between overflow-y-auto p-4 gap-10">
                    <div className="flex-col gap-4 overflow-y-auto">

                        <FormTextField
                            required
                            label="Client Name"
                            name="clientName"
                            handleChange={handleChange}
                        />
                        <FormTextField
                            required
                            label="Threshold"
                            name="threshold"
                            handleChange={handleChange}
                        />
                        <FormTextField
                            required
                            label="Spoofing Threshold"
                            name="spoofingThreshold"
                            handleChange={handleChange}
                        />
                        <Select
                            variant="standard"
                            fullWidth
                            name="isActive"
                            value={values.isActive}
                            onChange={(e) => setFieldValue('isActive', e.target.value)}
                            displayEmpty
                            renderValue={(value) => {
                                const option = booleanOption.find((v) => v.value === value)
                                return option ? option.label : 'isActive'
                            }}
                            sx={{
                                fontSize: '1rem',
                                '&::before': {
                                    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
                                },
                                '&:hover:not(.Mui-disabled)::before': {
                                    borderBottom: '2px solid black',
                                },
                            }}
                        >
                            {booleanOption.map((menuItem) => (
                                <MenuItem key={menuItem.value.toString()} value={menuItem.value}>
                                    {menuItem.label}
                                </MenuItem>
                            ))}
                        </Select>
                        {!isEdit && (
                            <FormTextField
                                required
                                label="Password"
                                name="password"
                                type="password"
                                handleChange={handleChange}
                            />
                        )}
                    </div>

                    <div className="flex items-center justify-end gap-2.5">
                        <CancelBtn
                            onClick={onClose}
                            title="Cancel"
                            type="button"
                        />

                        <PrimaryBtn
                            loading={loading}
                            title={isEdit ? 'Edit' : 'Create'}
                            type="submit"
                        />
                    </div>
                </Form>
            )}
        </Formik>
    )
}
